import styled from "styled-components";
import { media } from '../../../theme';

export const Header = styled.div`
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  flex-direction: column;
  align-items: flex-start;

  button {
    width: 100%;
  }

  h2 {
    margin: 0;
    flex: 1;
  }

  ${media.sm} {
    flex-direction: row;
    align-items: center;

    button {
      width: auto;
    }
  }
`;

export const StyledTableWrapper = styled.div`
    margin-top: 16px;
    width: 100%;
`;

export const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;

    thead {
        font-weight: bold;
        font-size: 18px;
    }
`;

export const StyledTableRow = styled.tr`
    &:nth-child(even) {
        background-color: #f5f7fa;
    }

    transition: background-color 200ms ease;
    cursor: pointer;

    &:hover {
        background-color: rgba(225, 235, 245, 0.7);
    }
`;

export const StyledTableCell = styled.td`
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid #e5edf3;
`;
